      
import { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import GuestGuard from './components/Auth/GuestGuard';
import AuthGuard from './components/Auth/AuthGuard';
import HomeGuard from './components/Auth/HomeGuard'

import { BASE_URL } from './config/constant';

export const renderRoutes = (routes = []) => (
    <Suspense fallback={<Loader />}>
        <Routes>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;

                return (
                    <Route
                        key={i}
                        path={route.path}
                        element={
                            <Guard>
                                <Layout>{route.routes ? renderRoutes(route.routes) : <Component />}</Layout>
                            </Guard>
                        }
                    />
                );
            })}
        </Routes>
    </Suspense>
);

const routes = [
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signin',
        component: lazy(() => import('./views/auth/signin/SignIn1'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signup',
        component: lazy(() => import('./views/auth/signup/SignUp1'))
    },
    {
        path: '*',
        layout: AdminLayout,
        guard: AuthGuard,
        routes: [
            //--------------------SOLICITUDES----------------
            {
                exact: false,
                guard: HomeGuard,
                path: '/app/admin/solicitudes/dashboard',
                component: lazy(() => import('./views/estadisticas_solicitudes/solicitudes'))
            },

            {
                exact: true,
                path: '/app/admin/solicitudes',
                component: lazy(() => import('./views/solicitudes/solicitudes_admin'))
            },

            {
                exact: true,
                path: '/app/user/solicitudes',
                component: lazy(() => import('./views/solicitudes/solicitudes_departamento'))
            },

            {
                exact: true,
                path: '/app/compras/solicitudes',
                component: lazy(() => import('./views/solicitudes/solicitudes_compras'))
            },

            {
                exact: true,
                path: '/app/user/solicitud',
                component: lazy(() => import('./views/solicitudes/solicitud_form'))
            },
            {
                exact: true,
                path: '/app/user/solicitud/editar/:id',
                component: lazy(() => import('./views/solicitudes/solicitud_editar'))
            },

            //--------------------CONTRATOS----------------
            {
                exact: true,
                path: '/app/admin/contratos',
                component: lazy(() => import('./views/contratos/contratos_admin'))
            },

            {
                exact: true,
                path: '/app/admin/contratos-administradors',
                component: lazy(() => import('./views/contratos/contratos_administracion'))
            },

            {
                exact: true,
                path: '/app/admin/contratos-archivados',
                component: lazy(() => import('./views/contratos/contratos_archivados'))
            },

            {
                exact: true,
                path: '/app/admin/contratos/editar/:id',
                component: lazy(() => import('./views/contratos/contrato_editar'))
            },

            {
                exact: true,
                path: '/app/user/contratos',
                component: lazy(() => import('./views/contratos/contratos_departamento'))
            },

            {
                exact: true,
                path: '/app/user/contrato',
                component: lazy(() => import('./views/contratos/contrato_form'))
            },

            {
                exact: true,
                path: '/app/user/contratos/accion/:codigo',
                component: lazy(() => import('./views/contratos/contrato_accion'))
            },



            //----------------DOCUMENTOS--------------
            {
                exact: true,
                path: '/app/user/documents-intranet',
                component: lazy(() => import('./views/documentos/intranet/documentos_intranet'))
            },
            {
                exact: true,
                path: '/app/user/documents-circulars',
                component: lazy(() => import('./views/documentos/intranet/documents_circulars'))
            },
                        {
                exact: true,
                path: '/app/user/documents-nota-informativa',
                component: lazy(() => import('./views/documentos/intranet/documentos_nota_informativa'))
            },

            //----------------FORMACION----------------
            {
                exact: true,
                path: '/app/admin/formacions',
                component: lazy(() => import('./views/formacion/formacion_admin'))
            },
            {
                exact: true,
                path: '/app/user/formacio',
                component: lazy(() => import('./views/formacion/formacion_form'))
            },
            {
                exact: true,
                path: '/app/admin/formacions/editar/:id',
                component: lazy(() => import('./views/formacion/formacion_editar'))
            },

            {
                exact: true,
                path: '/app/admin/formacions/previsualitzar/:id',
                component: lazy(() => import('./views/formacion/components/prevFormacion'))
            },

            //----------------FORMACION----------------
            {
                exact: true,
                path: '/app/admin/lligatalent/clubs',
                component: lazy(() => import('./views/lligatalent/lligatalent_admin'))
            },
            {
                exact: true,
                path: '/app/admin/lligatalent/club/:id',
                component: lazy(() => import('./views/lligatalent/lligatalent_club'))
            },
            {
                exact: true,
                path: '/app/admin/lligatalent/club/equip/:id',
                component: lazy(() => import('./views/lligatalent/lligatalent_equipo'))
            },
            {
                exact: true,
                path: '/app/admin/lligatalent/club/equip/persona/:id',
                component: lazy(() => import('./views/lligatalent/lligatalent_persona'))
            },

            //----------------COMUNICACION----------------
            {
                exact: true,
                path: '/app/admin/noticies',
                component: lazy(() => import('./views/noticies/noticies_admin'))
            },
            {
                exact: true,
                path: '/app/user/noticia',
                component: lazy(() => import('./views/noticies/noticies_form'))
            },
            {
                exact: true,
                path: '/app/admin/noticies/editar/:id',
                component: lazy(() => import('./views/noticies/noticies_editar'))
            },
            {
                exact: true,
                path: '/app/admin/noticies/previsualitzar/:id',
                component: lazy(() => import('./views/noticies/components/prevNoticia'))
            },
            {
                exact: true,
                path: '/app/admin/galeries',
                component: lazy(() => import('./views/galeries/galeries_admin'))
            },
            {
                exact: true,
                path: '/app/user/galeria',
                component: lazy(() => import('./views/galeries/galeries_form'))
            },
            {
                exact: true,
                path: '/app/admin/galeries/editar/:id',
                component: lazy(() => import('./views/galeries/galeries_editar'))
            },
            {
                exact: true,
                path: '/app/admin/streamings',
                component: lazy(() => import('./views/app/streamings/streamings_admin'))
            },
            {
                exact: true,
                path: '/app/user/streamings',
                component: lazy(() => import('./views/app/streamings/streamings_form'))
            },
            {
                exact: true,
                path: '/app/admin/streamings/editar/:id',
                component: lazy(() => import('./views/app/streamings/streamings_editar'))
            },
            {
                exact: true,
                path: '/app/admin/playlists',
                component: lazy(() => import('./views/app/playlists/playlists_admin'))
            },
            {
                exact: true,
                path: '/app/user/playlists',
                component: lazy(() => import('./views/app/playlists/playlists_form'))
            },
            {
                exact: true,
                path: '/app/admin/playlists/editar/:id',
                component: lazy(() => import('./views/app/playlists/playlists_editar'))
            },
            {
                exact: true,
                path: '/app/admin/esdeveniments',
                component: lazy(() => import('./views/app/eventos/eventos_admin'))
            },
            {
                exact: true,
                path: '/app/admin/enquesta',
                component: lazy(() => import('./views/app/encuesta/encuesta_admin'))
            },

            //--------------------FORMS----------------

            {
                exact: true,
                path: '/app/forms/campuslcfs',
                component: lazy(() => import('./views/forms/campuslcfs/campuslcfs'))
            },
            {
                exact: true,
                path: '/app/forms/desafiamentsporters',
                component: lazy(() => import('./views/forms/desafiaments/desafiaments'))
            },
            {
                exact: true,
                path: '/app/forms/diaentrenadors',
                component: lazy(() => import('./views/forms/diaentrenador/diaentrenador'))
            },
            {
                exact: true,
                path: '/app/forms/clinicentrenadors',
                component: lazy(() => import('./views/forms/clinicentrenador/clinicentrenador'))
            },
            {
                exact: true,
                path: '/app/forms/diaentrenadors/acredita',
                component: lazy(() => import('./views/forms/diaentrenador/acredita'))
            },

            //--------------------ASEEMBLEES----------------

            {
                exact: true,
                path: '/app/assemblea/convenciolcfs/registre',
                component: lazy(() => import('./views/asambleas/convenciolcfs/registre'))
            },
            {
                exact: true,
                path: '/app/assemblea/convenciolcfs/checkin',
                component: lazy(() => import('./views/asambleas/convenciolcfs/checkin'))
            },
            {
                exact: true,
                path: '/app/assemblea/convenciolcfs/assistents',
                component: lazy(() => import('./views/asambleas/convenciolcfs/assistents'))
            },
            {
                exact: true,
                path: '/app/assemblea/generalordinaria/registre',
                component: lazy(() => import('./views/asambleas/generalordinaria/registre'))
            },
            {
                exact: true,
                path: '/app/assemblea/generalordinaria/checkin',
                component: lazy(() => import('./views/asambleas/generalordinaria/checkin'))
            },
            {
                exact: true,
                path: '/app/assemblea/generalordinaria/assistents',
                component: lazy(() => import('./views/asambleas/generalordinaria/assistents'))
            },

            //--------------------STOCK---------------------
            {
                exact: true,
                path: '/app/stock/admin',
                component: lazy(() => import('./views/stock/stock_admin'))
            },
            {
                exact: true,
                path: '/app/user/producte',
                component: lazy(() => import('./views/stock/stock_form'))
            },
            {
                exact: true,
                path: '/app/admin/stock/editar/:id',
                component: lazy(() => import('./views/stock/stock_editar'))
            },
            {
                exact: true,
                path: '/app/user/transaccio',
                component: lazy(() => import('./views/stock/stock_transaccion'))
            },
            {
                exact: true,
                path: '/app/admin/transaccions',
                component: lazy(() => import('./views/stock/transaccions_admin'))
            },
            {
                exact: true,
                path: '/app/admin/transaccio/editar/:id',
                component: lazy(() => import('./views/stock/transaccion_editar'))
            },

            //--------------------COMPLIANCE----------------
            {
                exact: true,
                path: '/app/compliance/denuncies',
                component: lazy(() => import('./views/compliance/denuncias'))
            },

            //--------------------SORTEJOS----------------
            {
                exact: true,
                path: '/app/sortejos/grups-competicio',
                component: lazy(() => import('./views/sorteos/grups-competicio'))
            },

            //--------------------USERS----------------
            {
                exact: true,
                path: '/app/auth/users-admin',
                component: lazy(() => import('./views/auth/users_admin'))
            },
            {
                exact: true,
                path: '/app/auth/user-profile',
                component: lazy(() => import('./views/auth/user_profile'))
            },

            //--------------------PROVEEDORES----------------
            {
                exact: true,
                path: '/app/proveedores/admin',
                component: lazy(() => import('./views/proveedores/administrador'))
            },
            {
                exact: true,
                path: '/app/kilometraje/grupos',
                component: lazy(() => import('./views/kilometraje/grupos'))
            },
            {
                exact: true,
                path: '/basic/breadcrumb',
                component: lazy(() => import('./views/ui-elements/basic/BasicBreadcrumb'))
            },
            {
                exact: true,
                path: '/basic/collapse',
                component: lazy(() => import('./views/ui-elements/basic/BasicCollapse'))
            },
            {
                exact: true,
                path: '/basic/tabs-pills',
                component: lazy(() => import('./views/ui-elements/basic/BasicTabsPills'))
            },
            {
                exact: true,
                path: '/basic/typography',
                component: lazy(() => import('./views/ui-elements/basic/BasicTypography'))
            },

            {
                exact: true,
                path: '/forms/form-basic',
                component: lazy(() => import('./views/forms/FormsElements'))
            },
            {
                exact: true,
                path: '/tables/bootstrap',
                component: lazy(() => import('./views/tables/BootstrapTable'))
            },

            {
                exact: true,
                path: '/charts/nvd3',
                component: lazy(() => import('./views/charts/nvd3-chart'))
            },

            {
                path: '*',
                exact: true,
                component: () => <Navigate to={BASE_URL} />
            }
        ]
    }
];

export default routes;
